"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleEvent = void 0;
var strongly_typed_events_1 = require("strongly-typed-events");
Object.defineProperty(exports, "SimpleEvent", { enumerable: true, get: function () { return strongly_typed_events_1.SimpleEventDispatcher; } });
//# sourceMappingURL=events.js.map